import { FC } from 'app/FunctionalComponent'
import React from 'react'
import classes from './FormStacked.module.scss'

export const FormRow: FC = (props: { children?: React.ReactNode }) => {
	return <div className={classes.formRow}>{props.children}</div>
}
